import request from '@/api/request'
export default {
    loginByCode(params) {
        // 根据参数判断是手机号还是邮箱登录
        const url = params.phone ? '/login/user/phone' : '/login/user/email'
        return request({
            url: url,
            method: 'post',
            params: params
        })
    },
    loginByPassword(params) {
        // 根据参数判断是手机号还是邮箱登录
        const url = params.phone ? '/login/user/password' : '/login/user/email/password'
        return request({
            url: url,
            method: 'post',
            params: params
        })
    },
    loginAdmin(params) {
        return request({
            url: '/login/admin',
            method: 'post',
            params: params
        })
    },
    logout() {  
        return request({
            url: '/logout',
            method: 'post'
        })
    },
    getVerificationCode(params){
        // 根据参数判断是手机号还是邮箱验证码
        // 手机号登录验证码：/sms/getVerificationCode
        // 邮箱登录验证码：/email/getLoginCode
        const url = params.phone ? '/sms/getVerificationCode' : '/email/getLoginCode'
        return request({
            url: url,
            method: 'post',
            params: params
        })
    },
    getRegisterCode(params){
        // 根据参数判断是手机号还是邮箱验证码
        // 手机号注册：/sms/getRegisterCode
        // 邮箱注册：/email/getRegisterCode
        const url = params.phone ? '/sms/getRegisterCode' : '/email/getRegisterCode'
        return request({
            url: url,
            method: 'post',
            params: params
        })
    },
    register(params){
        // 根据参数判断是手机号还是邮箱注册
        const url = params.phoneNumber ? '/register/user/phone' : '/register/user/email'
        return request({
            url: url,
            method: 'post',
            data: params
        })
    },
    // 获取重置密码验证码
    getResetPasswordCode(params){
        // 根据参数判断是手机号还是邮箱重置密码验证码
        // 手机号重置密码验证码：/user/resetPasswordCode
        // 邮箱重置密码验证码：/email/getResetPasswordCode
        const url = params.phone ? '/user/resetPasswordCode' : '/email/getResetPasswordCode'
        return request({
            url: url,
            method: 'post',
            params: params
        })
    },
    // 重置密码
    resetPassword(params){
        // 根据参数判断是手机号还是邮箱重置密码
        // 手机号重置密码：/user/updatePasswordByCode（参数：code, phone, newPassword）
        // 邮箱重置密码：/user/updatePasswordByEmailCode（参数：code, email, newPassword）
        const url = params.phone ? '/user/updatePasswordByCode' : '/user/updatePasswordByEmailCode'
        return request({
            url: url,
            method: 'post',
            data: params
        })
    },
}
